import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LoginService} from '../../services/login.service';
import {HttpErrorResponse} from '@angular/common/http';
import { FeatureToggleService } from '../../../shared/services/feature-toggle.service';
import { FeatureToggle } from '../../../shared/data-objects/feature-toggle';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  validationSummary: string;
  tempReturnUrl: string;
  _feature: FeatureToggle;

  constructor(private loginService: LoginService, private route: ActivatedRoute,
              private router: Router, private featureToggleService: FeatureToggleService) {
      this.route.url.subscribe(async url =>{
        await this.getFeatureToggle();
        if(this._feature && !this._feature.DisableGuestUsers && !this.loginService.isUserLoggedIn()) {
          this.loginService.guestLogin(this.guestLoginOkCb.bind(this), this.guestLoginErrorCb.bind(this));
        }
      });
  }

  async ngOnInit() {
    await this.loginService.refreshToken();
  }

  async getFeatureToggle() {
    this._feature = this.featureToggleService.features;
    if (!this._feature) {
      await this.featureToggleService.fetchFeatureToggles();
      this._feature = this.featureToggleService.features;
    }
  }

  navigateToApplication(route: string): void {
    // if (!this.loginService.isUserLoggedIn()) {
    //   if(!this._feature.DisableGuestUsers && this.loginService.isGuestUserLoggedIn()) {
    //     this.router.navigate([route]);
    //   } else {
    //     this.tempReturnUrl = '/' + route;
    //     //this.loginService.guestLogin(this.guestLoginOkCb.bind(this), this.guestLoginErrorCb.bind(this));
    //     this.router.navigate(['/login'], { queryParams: { returnUrl: this.tempReturnUrl }});
    //   }
    // } else {
    //   this.router.navigate([route]);
    // }

    this.tempReturnUrl = '/' + route;
    if (this.loginService.isUserLoggedIn()) {
      if (!this.loginService.isGuestUserLoggedIn() || (this.loginService.isGuestUserLoggedIn() && !this._feature.DisableGuestUsers)) {
        this.router.navigate([route]);
      } else {
        this.router.navigate(['/login'], { queryParams: { returnUrl: this.tempReturnUrl }});
      }
    } else {
      this.router.navigate(['/login'], { queryParams: { returnUrl: this.tempReturnUrl }});
    } 
  }

  guestLoginOkCb(ok: boolean): void {
    if (typeof (ok) === 'boolean') {
      if (!ok) {
        this.validationSummary = 'Error occurred while logging in guest user.';
      }
    }
    // this.router.navigate([this.tempReturnUrl]);
  }

  get isGuestUserLoggedIn(): boolean {
   return this.loginService.isGuestUserLoggedIn();
  }

  get isLogged(): boolean {
    return this.loginService.isUserLoggedIn();
  }

  guestLoginErrorCb(err: HttpErrorResponse): void {
    this.validationSummary = err.error.message;
  }

  get feature() {
    return this._feature;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/dashboard/dashboard.component.ts